import React, { Component } from 'react';
import * as Sentry from "@sentry/react";
import { NpoAudioPlayer } from '@npo/player';
import './NpoPlayer.scss';
import config from '../../config';

const getAudioToken = async channel => {
    try {
        const tokenUrl = await fetch(process.env.REACT_APP_API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                query: `query Tokens($channelSlug: String!) {
                    core_channels(slug: $channelSlug) {
                        data {
                            live_audio {
                                token_url
                            }
                        }
                    }
                }`,
                variables: { channelSlug: channel }
            })
        });
        const data = await tokenUrl.json();
        const audioTokenData = await fetch(
            data.data.core_channels.data[0].live_audio.token_url
        );
        const audioToken = await audioTokenData.json();
        return audioToken;
    } catch(error) {
        return Sentry.captureException(error);
    }
};

class NpoPlayerWrapper {
    constructor(player, tokenData) {
        this.player = player;
        this.tokenData = tokenData;
        this.streamLoaded = false;
        this.isPlaying = false;

        player.on('play', () => { this.isPlaying = true; });
        player.on('pause', () => { this.isPlaying = false; });
        player.on('ended', () => { this.isPlaying = false; });
    }

    async loadStreamIfNeeded() {
        if (this.streamLoaded || !this.tokenData?.playerToken) {
            return undefined;
        }

        return new Promise((resolve, reject) => {
            const onReady = () => {
                this.streamLoaded = true;
                this.player.off('loadedmetadata', onReady);
                resolve();
            };

            this.player.on('loadedmetadata', onReady);

            this.player.load(this.tokenData.playerToken, { autoplay: true })
                .catch(reject);
        });
    }

    destroy() { return this.player?.destroy(); }

    on(...args) { return this.player.on(...args); }

    off(...args) { return this.player.off(...args); }

    play(...args) { return this.player.play(...args); }

    pause(...args) { return this.player.pause(...args); }

    setVolume(...args) { return this.player.setVolume(...args); }
}

class NpoPlayer extends Component {
    componentDidMount() {
        this.initPlayer();
    }

    componentWillUnmount() {
        window.NpoPlayer?.destroy();
    }

    async initPlayer() {
        try {
            const { setPlayerReady, channel } = this.props;
            const { playerId } = config[channel];
            const tokenData = await getAudioToken(playerId);

            const container = document.getElementById('audio-player');

            const audioPlayer = new NpoAudioPlayer(container, {
                environmentDomain: tokenData.environmentDomain,
                npoTag: {
                    initprops: {
                        ...window.NpoTagContext,
                    },
                    pageTracker: window.tracker?.pageTracker,
                    npoTag: window.tracker?.npoTag,
                },
                uiFactory: undefined,
            });

            window.NpoPlayer = new NpoPlayerWrapper(audioPlayer, tokenData);
            
            await window.NpoPlayer.loadStreamIfNeeded();
            
            setPlayerReady(true);
        } catch (error) {
            Sentry.captureException(error);
        }
    }

    render() {
        return (
            <div
                id="audio-player"
                style={{ width: 0, height: 0, border: 0, display: 'none' }}
            />
        );
    }
}

export default NpoPlayer;
